/** Review deletion pricing — display-only until checkout is integrated. */

export const FREE_TIER_PACKAGES = [
  {
    id: "tier-small",
    reviewRange: "1–5 reviews",
    pricePerReview: 129,
    description: "Ideal for a small batch of reviews that must be removed together.",
    highlight: false,
  },
  {
    id: "tier-medium",
    reviewRange: "6–10 reviews",
    pricePerReview: 89,
    description: "Better per-review rate when you submit a medium-sized bulk case.",
    highlight: true,
  },
  {
    id: "tier-large",
    reviewRange: "11+ reviews",
    priceLabel: "11+ (unlimited volume)",
    pricePerReview: 79,
    description: "Our best per-review rate for large bulk deletion requests.",
    highlight: false,
  },
];

export const FREE_TIER_VOLUME_BANDS = [
  { range: "1-5 reviews", pricePerReview: 129 },
  { range: "6-10 reviews", pricePerReview: 89 },
  { range: "11+ reviews", pricePerReview: 79 },
];

export const FREE_TIER_FEATURES = [
  { included: true, text: "Basic review monitoring" },
  { included: false, text: "No included monthly deletions" },
  { included: false, text: "Manual case submission only" },
];

/** Basic plan — €79/month, same feature set as the free trial. */
export const BASIC_PLAN = {
  monthlyPrice: 79,
};

export const SUBSCRIBER_PLAN = {
  monthlyPrice: 179,
  freeDeletionsPerMonth: 2,
  additionalDeletionPrice: 79,
  features: [
    "2 Free deletions per month",
    "Reduced rate: €79 / case",
    "Advanced platform sync",
    "Priority support access",
  ],
};

export const ENTERPRISE_PLAN = {
  features: [
    "Unlimited monitoring",
    "Dedicated account manager",
    "Bulk volume discounts",
    "Full API & CRM integration",
  ],
};

export const PLAN_COMPARISON_ROWS = [
  {
    feature: "Billing Model",
    freeTier: "Pay-per-bulk deletion",
    professional: "Fixed monthly subscription",
    enterprise: "Annual commitment",
    professionalHighlight: true,
  },
  {
    feature: "Review Selection",
    freeTier: "Bulk deletion cases",
    professional: "Flexible — submit as needed",
    enterprise: "Automated system-wide removal",
    professionalHighlight: true,
  },
  {
    feature: "Included Deletions",
    freeTier: "None — priced per review",
    freeTierMuted: true,
    professional: "2 Free cases per month",
    professionalBold: true,
    enterprise: "Volume-based credits",
  },
  {
    feature: "Price per Review",
    freeTier: "Volume-based (from €79)",
    professional: "€79 (after included)",
    enterprise: "Dynamic scale pricing",
    professionalHighlight: true,
  },
  {
    feature: "Support Level",
    freeTier: "Documentation only",
    professional: "24h Priority support",
    enterprise: "Dedicated Manager 24/7",
  },
  {
    feature: "Reporting",
    freeTier: "Basic monthly summary",
    professional: "Real-time status updates",
    enterprise: "Custom BI Dashboards",
    professionalHighlight: true,
  },
];
